/**
 * 抽屉拖拽关闭防护 mixin。
 *
 * 解决问题：在 el-drawer 内部按下鼠标后拖拽到遮罩层松开时，
 * click 事件会冒泡到 .el-drawer__container，触发默认的"点击遮罩关闭抽屉"行为。
 *
 * 使用方式：
 *   1) 在组件上 mixins: [drawerDragCloseGuard]
 *   2) 在 <el-drawer> 内部最外层 div 上绑定 @mousedown="onDrawerBodyMouseDown"
 */
export default {
  methods: {
    /**
     * 抽屉内部 mousedown 时记录起点抽屉面板，监听一次 mouseup；
     * 若 mouseup 落点不在抽屉面板内（即被拖拽到遮罩层），
     * 则在 capture 阶段拦截下一次 click，阻止 el-drawer 默认的遮罩关闭。
     * 调用处：drawer 内部根 div 的 @mousedown
     * @param {MouseEvent} event - 原生 mousedown 事件
     */
    onDrawerBodyMouseDown(event) {
      const startEl = event && event.currentTarget;
      if (!startEl || typeof startEl.closest !== 'function') {
        return;
      }
      const drawerPanel = startEl.closest('.el-drawer');
      if (!drawerPanel) {
        return;
      }
      const onMouseUp = (upEvent) => {
        document.removeEventListener('mouseup', onMouseUp, true);
        const upTarget = upEvent && upEvent.target;
        if (upTarget && drawerPanel.contains(upTarget)) {
          return;
        }
        const blockClick = (clickEvent) => {
          document.removeEventListener('click', blockClick, true);
          if (clickEvent && typeof clickEvent.stopPropagation === 'function') {
            clickEvent.stopPropagation();
          }
        };
        document.addEventListener('click', blockClick, true);
      };
      document.addEventListener('mouseup', onMouseUp, true);
    }
  }
};
